import { useContext, useEffect, useState } from 'react';
import { Destructor } from 'app/shared/utilities/Destructor';
import { Scale } from 'app/agriculture/AgricultureMap/components/ScaleIndicator/ScaleIndicator.service';
import { ServicesContext } from 'app/items/shared/context_interface';

export const useScaleIndicator = () => {
    const { scaleIndicator } = useContext(ServicesContext);
    const [text, setText] = useState<string>('');
    const [width, setWidth] = useState<string>('0px');

    useEffect(() => {
        const destructor = new Destructor(
            scaleIndicator.onChange((scale: Scale) => {
                setText(scale.text);
                setWidth(`${scale.width}px`);
            }),
        );
        return destructor.destroy;
    }, [scaleIndicator]);

    return { text, width };
};
